import { IconAttributeTraveller } from '@components/icons/attribute-traveller';
import { IconTextShort } from '@components/icons/text-short';
import { TextField } from '@components/text-field';
import { getScopedTranslate } from '@locale/translate';
import { asteriskLabel } from '@utils/strings';

import { FieldDropzone } from './field-dropzone';

import { conditionsTab } from '../conditions-tab';
import { useFormBuilderContext } from '../context';
import { FieldEdit } from '../field-edit';
import { FieldConfig } from '../field-registry';
import { FieldSidebarLabel } from '../fields-sidebar';
import { RequiredSwitch } from '../required-switch';

type Config = FieldConfig<'input-kennitala'>;

const Display: Config['Display'] = ({ field }) => {
  return (
    <TextField
      label={asteriskLabel(field.label, field.isRequired)}
      placeholder={field.placeholder}
      labelIcon={field.companyAttributeId ? <IconAttributeTraveller size={16} /> : undefined}
    />
  );
};

const FormBuilderKennitala: Config['Component'] = ({ field, dragHandle }) => {
  const actions = useFormBuilderContext().store.actions;

  return (
    <FieldDropzone field={field}>
      <FieldEdit
        field={field}
        dragHandle={dragHandle}
        display={<Display field={field} />}
        edit={
          <>
            <TextField
              onChange={actions.createChangeHandler(field, 'label')}
              defaultValue={field.label}
              label={t('label')}
              maxChars={255}
            />
            <TextField
              onChange={actions.createChangeHandler(field, 'placeholder')}
              defaultValue={field.placeholder}
              label={t('placeholder')}
            />
            <RequiredSwitch field={field} />
          </>
        }
      />
    </FieldDropzone>
  );
};

const { t } = getScopedTranslate({
  en: {
    title: 'Kennitala',
    label: 'Label',
    placeholder: 'Placeholder text',
  },
});

export const kennitalaConfig: Config = {
  kind: 'input-kennitala',
  title: t('title'),
  group: 'inputs',
  propertiesTabs: [conditionsTab],
  Display,
  TreeDisplay: ({ field }) => <FieldSidebarLabel label={field.label} />,
  Icon: IconTextShort,
  Component: FormBuilderKennitala,
};
